import src from "IMAGE";
export default { src, width: 2140, height: 445, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQElEQVR42hWKSQrAMAgA84PWQ5EijQt6adD/Py9xTsMwQ0QmIj7M/LW7uxHRCwD34RqZ+VfV6qGjmWmPEWGqOjfw/geFKNueLgAAAABJRU5ErkJggg=="};
